var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import { FormContext } from "../../../common/context/context";
import Icons from '../../../icons';
import { ErrorMessage } from '../input/input.styles';
import { ErrorSpan } from '../input/input.styles';
import { LangHelper } from '../lang/helper';
import LangMessage from '../lang/message';
import { DropdownSection, CustomInputWithDropDown, DropdownList, DropdownListItem, SearchIcon, SelectArrow, SelectLine, CustomLabel, DropDownWrapper, RequiredAsterisk } from './dropdown.styles';
var DropdownInput = function (props) {
    var options = props.options, label = props.label, htmlForm = props.htmlForm, placeholder = props.placeholder, required = props.required, onChange = props.onChange, onSelect = props.onSelect, icon = props.icon, inputValue = props.inputValue, setInputValue = props.setInputValue, maxResultsOptions = props.maxResultsOptions, onClick = props.onClick, errorMessage = props.errorMessage, ddWidth = props.ddWidth, widthFull = props.widthFull, inputWidth = props.inputWidth, showArrow = props.showArrow, showOptions = props.showOptions;
    var state = React.useContext(FormContext).state;
    var _a = React.useState(label), labelValue = _a[0], setLabelValue = _a[1];
    var _b = React.useState(placeholder), placeholderValue = _b[0], setPlaceholderValue = _b[1];
    useEffect(function () {
        if (label) {
            var translatedLabelValue = LangHelper.getLangMessageValue(label, state.lang);
            setLabelValue(translatedLabelValue);
        }
        var translatedPlaceholderValue = LangHelper.getLangMessageValue(placeholder, state.lang);
        setPlaceholderValue(translatedPlaceholderValue);
    }, [state]);
    var _c = useState(false), isDropdownVisible = _c[0], setIsDropdownVisible = _c[1];
    var _d = useState([]), visibleOptions = _d[0], setVisibleOptions = _d[1];
    var dropdownRef = useRef(null);
    var handleKeyPress = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };
    useEffect(function () {
        var handleDocumentClick = function (event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownVisible(false);
            }
        };
        document.addEventListener('mousedown', handleDocumentClick);
        return function () {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, []);
    useEffect(function () {
        if (showOptions) {
            setIsDropdownVisible(Array.isArray(options) && options.length > 0);
        }
        setVisibleOptions(Array.isArray(options) ? options.slice(0, maxResultsOptions || options.length) : []);
    }, [options, maxResultsOptions]);
    var handleInputChange = function (event) {
        var newValue = event.target.value;
        setInputValue(newValue);
        onChange && onChange(event);
    };
    var handleOptionSelect = function (option) {
        if (typeof option !== 'string') {
            setInputValue && setInputValue(option.text || option.description);
            setIsDropdownVisible(false);
            onSelect && onSelect(option.text || option.place_id);
        }
        else {
            setInputValue(option);
            setIsDropdownVisible(false);
            onSelect && onSelect(option);
        }
    };
    var handleInputFocus = function () {
        if (options.length > 0) {
            setIsDropdownVisible(true);
        }
    };
    var dropdownSectionStyles = isDropdownVisible ? { borderBottom: '1px solid white' } : {};
    var withIconStyles = icon ? { paddingLeft: '50px' } : {};
    return (_jsxs(DropDownWrapper, __assign({ "$width": inputWidth }, { children: [labelValue && _jsxs(CustomLabel, __assign({ htmlFor: htmlForm }, { children: [labelValue, " ", required && _jsx(RequiredAsterisk, { children: " *" })] })), _jsxs(DropdownSection, __assign({ style: dropdownSectionStyles, ref: dropdownRef }, { children: [icon && _jsx(SearchIcon, { alt: "map", src: Icons.iconMap }), _jsx(CustomInputWithDropDown, { style: withIconStyles, type: "text", onChange: handleInputChange, placeholder: placeholderValue, value: inputValue, onClick: onClick, onKeyDown: handleKeyPress, onFocus: handleInputFocus, "$width": ddWidth, "$widthFull": widthFull }), errorMessage && (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.length) > 0 && _jsx(ErrorSpan, {}), showArrow || isDropdownVisible ? (_jsx(SelectArrow, { alt: 'arrow', src: Icons.selectArrow })) : null, isDropdownVisible && (_jsxs(DropdownList, { children: [_jsx(SelectLine, {}), visibleOptions.length > 0 ? (visibleOptions.map(function (option, index) { return (_jsx(DropdownListItem, __assign({ onClick: function () { return handleOptionSelect(option); }, style: withIconStyles }, { children: option.description ? option.description : (option.text ? _jsx(LangMessage, { msgKey: option.text, defaultValue: option.text }) : option) }), index)); })) : (_jsx(DropdownListItem, { children: _jsx(LangMessage, { msgKey: 'form.noResult' }) }))] }))] })), errorMessage && _jsx(ErrorMessage, { children: _jsx(LangMessage, { msgKey: errorMessage }) })] })));
};
export default DropdownInput;
